import React from "react";

function formatSecondsAgo(seconds: number): string {
  if (seconds < 60) return `Vor ${seconds} Sek.`;
  const mins = Math.floor(seconds / 60);
  return `Vor ${mins} Min.`;
}

function RefreshIcon({ spinning }: { spinning: boolean }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={spinning ? "animate-spin" : ""}
      style={{ animationDirection: "reverse" }}
      aria-hidden="true"
    >
      <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8" />
      <path d="M21 3v5h-5" />
    </svg>
  );
}

interface Props {
  /** Seconds since the list last came back from the API, or `null` before the first response. */
  secondsAgo: number | null;
  isFetching: boolean;
  onRefresh: () => void;
  className?: string;
}

/**
 * Connection state plus a manual refresh. Sits in the page header on desktop and on its own row
 * above the list on a phone, where it would otherwise be wider than the title beside it.
 */
export const WorkOrderSyncStatus: React.FC<Props> = ({
  secondsAgo,
  isFetching,
  onRefresh,
  className,
}) => (
  <div
    className={`flex items-center gap-2 rounded-full bg-white px-3 py-1.5 text-[13px] font-medium text-[#004494] shadow-sm md:px-4 md:py-2 md:text-[15px] ${className ?? ""}`}
  >
    <span className="flex items-center gap-1.5">
      <span className="h-2.5 w-2.5 shrink-0 rounded-full bg-green-500" />
      <span className="font-semibold">Verbunden</span>
    </span>

    <span className="h-4 w-px bg-gray-300" />

    <span className="min-w-0 truncate text-gray-500">
      {secondsAgo === null
        ? "Noch nicht aktualisiert"
        : `${formatSecondsAgo(secondsAgo)} aktualisiert`}
    </span>

    <button
      onClick={onRefresh}
      disabled={isFetching}
      // 36 px on a phone rather than the desktop 32 — it is the only tap target in this row.
      className="ml-auto flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#E6F0FB] text-[#004494] transition hover:brightness-95 disabled:opacity-60 md:ml-1 md:h-8 md:w-8"
      title="Aktualisieren"
      aria-label="Aktualisieren"
      type="button"
    >
      <RefreshIcon spinning={isFetching} />
    </button>
  </div>
);
